import { render, staticRenderFns } from "./educateInstitute.vue?vue&type=template&id=a51b6584&scoped=true"
import script from "./educateInstitute.vue?vue&type=script&lang=js"
export * from "./educateInstitute.vue?vue&type=script&lang=js"
import style0 from "./educateInstitute.vue?vue&type=style&index=0&id=a51b6584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51b6584",
  null
  
)

export default component.exports